<template>
  <div :class="classes">
      <pt-page-title title="商品详情"></pt-page-title>
      <div :class="$style['goods-detail-all-massage']" v-loading="loading">
          <div :class="$style['goods-detail-message']">
            <goods-message :goodsData="goodsData" :goodsDetail="goods_detail" :justShow="justShow" :specificationsItems="specificationsItems"  :isGENE="isGENE"
            :goodsUrl="goodsUrl" :isThirdParty="isThirdParty" :isExternalUrl="isExternalUrl" @tdMaxWidth="getTdMaxWidth" :isPublished="isPublished"></goods-message>
            <after-sales-message :goodsData="goodsData" :afterSalesPolicyDTO="afterSalesPolicyDTO" v-if="isShowAfterSales" :tdMaxWidth="tdMaxWidth"></after-sales-message>
          </div>
        <div :class="$style['review-iframe-div']">
            <div :class="$style['review-iframe-div-content']">
                <pt-sub-title  class="pt-sub-title-iframe" title="商品预览"></pt-sub-title>
                <div :class="$style['pt-sub-title-iframe-content']">
                    <iframe :src="apiServer+'/commodity-detail/'+id+'?platform=PC'" :class="$style['review-iframe']" frameborder="0"></iframe>
                </div>
            </div>
        </div>
      </div>
        <!-- <div  class="goods-url-div-message">商品链接：<div class="goods-url-div"><span class="goods-url-text">{{goodsUrl}}</span><pt-copy-button :downloadUrl="goodsUrl"></pt-copy-button></div></div> -->
  </div>
</template>

<script>
// 组件class前缀
import goodsMessage from './goods-message'
import afterSalesMessage from './after-sales-message'
const prefixCls = 'pt-goods-detail'
export default {
  name: 'pt-goods-detail',
  components: {
    goodsMessage,
    afterSalesMessage
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    goodsData () {
      return (this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData) || {}
    },
    justShow () {
      return this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData && this.goods_detail.goodsDTO.goodsData.justShow
    },
    specificationsItems () {
      return (this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData && this.goods_detail.goodsDTO.goodsData.specifications && this.goods_detail.goodsDTO.goodsData.specifications[0] && this.goods_detail.goodsDTO.goodsData.specifications[0].items && this.goods_detail.goodsDTO.goodsData.specifications[0].items) || []
    },
    isThirdParty () {
      return this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData && this.goods_detail.goodsDTO.goodsData.goodsBelong === 'THIRD_PARTY'
    },
    isGENE () {
      return this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData && this.goods_detail.goodsDTO.goodsData.type === 'GENE'
    },
    afterSalesPolicyDTO () {
      return this.goods_detail.afterSalesPolicyDTO || {}
    },
    isExternalUrl () {
      return this.goods_detail.goodsDTO && this.goods_detail.goodsDTO.goodsData && this.goods_detail.goodsDTO.goodsData.isExternalUrl
    },
    // 是否显示售后政策
    isShowAfterSales () {
      return !this.isExternalUrl
    }
  },
  props: {
    goodsDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    },
    goodsUrl: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    isPublished: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      goods_detail: this.goodsDetail || {},
      apiServer: this.$apiServerMobile,
      tdMaxWidth: ''
    }
  },
  watch: {
    goodsDetail: {
      handler: function (val) {
        this.goods_detail = val
      },
      deep: true
    }
  },
  methods: {
    getTdMaxWidth (val) {
      this.tdMaxWidth = val
    }
  }
}
</script>

<style module lang="less">
@import "~less/var";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.goods-detail-all-massage{
    display: flex;
}
.goods-detail-message{
    color: #2D2D2D!important;
    display: flex;
    width: 65%;
    min-width: 600Px;
    flex-direction: column;
    padding-right: 10px;
}
.picture-tr{
    :global
    td{
    padding: 10px 0;
    }
}
.review-iframe{
    width: 100%;
    height: 100%;
}
.review-iframe-div{
    padding-top:15px;
    max-height: 800px;
    :global
    .pt-sub-title-iframe{
        margin: 0
    }
}
.review-iframe-div-content{
    height: 100%;
    display: flex;
    flex-direction: column
}
.pt-sub-title-iframe-content{
    height: 100%
}

</style>
<style lang="less">
// .goods-url-div-message{
//     display: flex;
//     line-height:40px;
//     padding:0
// }
</style>
